import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=3f07e630&scoped=true"
import script from "./editor.vue?vue&type=script&lang=js"
export * from "./editor.vue?vue&type=script&lang=js"
import style0 from "./editor.vue?vue&type=style&index=0&id=3f07e630&prod&langs=css&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f07e630",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Outputs/Images/PhotoEditor/components/editor.vue
// module id = 1390
// module chunks = 31